import {useMutation} from 'react-query';
import {updateExistingOrganizations} from '../Calls/Admin';

export const useUpdateExistingOrganizations = () => {
  return useMutation(updateExistingOrganizations);
};
